import { FieldArray } from "formik";
import React from "react";

import {
    Button,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { Autocomplete } from '@mui/material';
import { PopoverLink } from "../../../../common";
import { RULE_CRITERIA_DATE, RULE_CRITERIA_INT, RULE_CRITERIA_LONG, RULE_CRITERIA_STRING } from "../../../../store/constants/contract";
import { alphabets, dateEquators, FIELD_TYPE_DATE, integerEquators, StringEquators } from "../../../../store/constants/pages";
import { ContractsSearchComponent } from "../../ContractsSearchComponent";
import ContractOverrideCriteriaFieldArray from "./ContractOverrideCriteriaFieldArray";

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        width: '85%',
        marginLeft: theme.spacing(1),
    },
    formControl: {
        width: '85%',
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
    },
    autoComplete: {
        width: '85%',
        marginLeft: theme.spacing(1),
    },
    button: {
        margin: theme.spacing(1)
    },
    iconButton: {
        marginTop: theme.spacing(3),
    },
    clearButton: {
        marginTop: theme.spacing(3),
        marginLeft: '10px',
        color: 'rgba(0, 0, 0, 0.54)'
    },
    input: {
        marginTop: theme.spacing(4),
        width: '90%',
    },
    selectionIcon:{
        width:"100%",
        margin:'0 !important',
        padding:'0 !important' 
    },
    selectionIconButton:{
        width:"100%",
        '&:hover': {
            background: 'none !important',
        }
    },
    addButton: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    grouperGrid: {
        paddingBottom: theme.spacing(1), 
        borderBottom: '1px solid #e0e0e0'
    }
}));

export default function ContractOverrideGroupFieldArray({
    values, handleBlur, handleChange, touched, errors, contractOverrideCriteria, 
    tinyContracts, setFieldValue, npiRoles, disabled, facilities
}) {
    const classes = useStyles();

    function getHelperText(key, index) {
        if (errors.contractOverrideGroupXref) {
            if (errors.contractOverrideGroupXref[index]) {
                return errors.contractOverrideGroupXref[index][key];
            }
            return false;
        }
        return false;
    }

    function getError(key, index) {
        if (touched.contractOverrideGroupXref) {
            if (touched.contractOverrideGroupXref[index]) {
                return touched.contractOverrideGroupXref[index][key];
            }
            return false;
        }
        return false;
    }

    return (
        (<FieldArray
                name="contractOverrideGroupXref"
                render={({ remove, insert }) => (
                    <Grid container>
                        <Grid item xs={12}>
                            {values.contractOverrideGroupXref?.map((overrideGroup, index) =>
                                <Grid container key={`contractOverrideGroupXref-${index}`} className={classes.grouperGrid}>
                                    <Grid item xs={7}>
                                        <ContractOverrideCriteriaFieldArray
                                            overrideGroup={overrideGroup}
                                            contractOverrideCriteria={contractOverrideCriteria}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            touched={touched}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                            npiRoles={npiRoles}
                                            disabled={false}
                                            facilities={facilities}
                                            groupIndex={index}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sx={{ display: 'flex', alignItems: 'center'}}>
                                        <ContractsSearchComponent 
                                            disabled={disabled}
                                            icon={
                                            <Autocomplete
                                                open={false}
                                                disabled={disabled}
                                                onKeyDown={(e) => { e.preventDefault(); }}
                                                className={classes.autoComplete}
                                                value={overrideGroup.overrideContractId}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                options={tinyContracts}
                                                getOptionLabel={(option) => option.name}
                                                onChange={(obj, updatedContracts, event) => {
                                                    if (event === "clear") {
                                                        setFieldValue(`contractOverrideGroupXref.${index}.overrideContractId`, null);                                                   
                                                    }}}
                                                onBlur={handleBlur}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        name={`contractOverrideGroupXref.${index}.overrideContractId`}
                                                        label="Override Contract"
                                                        error={Boolean(getHelperText('overrideContractId', index) && getError('overrideContractId', index))}
                                                        helperText={getError('overrideContractId', index) ? getHelperText('overrideContractId', index) : ''}
                                                        margin="normal" />
                                                }
                                            />}
                                        handleSetContract={(value) => setFieldValue(`contractOverrideGroupXref.${index}.overrideContractId`, value)}
                                        chipBoxClass={classes.selectionIcon} iconButtonClass={classes.selectionIconButton}

                                        />
                                    </Grid>
                                    <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center'}}>
                                        <Grid container>
                                        {(index >= 0 && values.contractOverrideGroupXref.length > 1) && (
                                            <>
                                            <IconButton
                                                edge="start"
                                                aria-label="Delete"
                                                onClick={() => remove(index)}
                                                className={classes.iconButton}
                                                size="large">
                                                <DeleteIcon />
                                            </IconButton>
                                            </>
                                        )}
                                        </Grid>
                                    </Grid>
                                    
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                )}
            />)
    );
}
